import React, { createContext, useContext, useState } from 'react';

interface SearchContextProps {
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
}

export const SearchContext = createContext<SearchContextProps>({
  searchTerm: '',
  setSearchTerm: () => {},
});

export const useSearch = () => useContext(SearchContext);

interface SearchProviderProps {
  children: React.ReactNode;
}

export const SearchProvider: React.FC<SearchProviderProps> = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
      {children}
    </SearchContext.Provider>
  );
};
